import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { NaverKeys } from "../service/keys";

/*
* @description 네이버 매장 정보 무효화
*/
export const useNaverShopInfoInvalidate = () => {
    const queryClient = useQueryClient();

	return useCallback(() => {
		queryClient.invalidateQueries({ queryKey: NaverKeys.shopInfoAll() });
	}, [queryClient]) 
}

export const useNaverBizItemInvalidate = () => {
	const queryClient = useQueryClient();

	return useCallback(() => {
		queryClient.invalidateQueries({ queryKey: NaverKeys.bizItemAll() });
	}, [queryClient])
}